import React, { Component } from 'react'
import Fold from '../imgs/productfold.png'
import Product1 from '../imgs/product1.png'
import Product2 from '../imgs/product2.png'
import Product3 from '../imgs/product3.png'
import Product4 from '../imgs/product4.png'
import Product5 from '../imgs/product5.png'
import Product6 from '../imgs/product6.png'
import './products.css'

export class products extends Component {
    render() {
        return (
            <div id="products-con">
                <div id="product-fold">
                 <img id="product-fold-img" alt="des" src={Fold}/> 
                </div>
                <div id="shop-con">

                   <h1 id="product-title">Shop Our Product</h1> 
                    <div id="shop-btn-con">
                    <p id="underlined" className="shop-btn-text">View All</p>
                    <p className="shop-btn-text"> Featured Products</p>
                    <p className="shop-btn-text">Shop by Category<span><svg width="16" height="9" viewBox="0 0 16 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 0.5L8 7.5L15 0.5" stroke="#6F7CB2"/></svg></span></p>  
                    </div>    

                  
                    <div className="shop-div-flex">   
                        <div className="shop-div">
                            <img src={Product1} alt="des" className="shop-img"/>
                            <p className="shop-text">50 Pack 3 Ply Disposable Blue Protective Safety Face Mask With Ear Loops for Dust, Air PollutionHigh Filtration and Ventilation to Help Reduce the Spread of Viruses and Flu-Like Illnesses</p>
                            <p className="shop-price">$14.99</p>
                            <button className="shop-btn">Buy</button>
                        </div>
                        <div className="shop-div">
                        <img src={Product2} alt="des" className="shop-img"/>
                            <p className="shop-text">10 Pack FDA Approved Face ShieldFull Coverage Reusable Ultra Clear Full Personal Protective PPE Safety Face Shield with Extra Thick Hypoallergenic Foam Band for use with Eyewear</p>
                            <p className="shop-price">$21.00</p>
                            <button className="shop-btn">Buy</button>
                        </div>
                        </div>


                        <div className="shop-div-flex">
                        <div className="shop-div">
                            <img src={Product3} alt="des" className="shop-img"/>
                            <p className="shop-text">Adjustable Non-Slip Mask Extension Strap5 Pack |Soft Ear Protection Strap with Secure Hooks | Made in USA | Suitable for Adults and Children | Environmentally Friendly Flexible Mask Buckle</p>
                            <p className="shop-price">$8.99</p>
                            <button className="shop-btn">Buy</button>
                        </div>
                        <div className="shop-div">
                        <img src={Product4} alt="des" className="shop-img"/>
                            <p className="shop-text">Cam Walker Fracture Boot Rocker Bottom Medial Lateral Air BlatterPromotes Natural Walking – Rocker sole and shock-absorbing insole promote more natural walking during use</p>
                            <p className="shop-price">$45.00</p>
                            <button className="shop-btn">Buy</button>
                        </div>
                        </div>


                        <div className="shop-div-flex">
                        <div className="shop-div">
                            <img src={Product5} alt="des" className="shop-img"/>
                            <p className="shop-text">Knee Immobilizer Brace for Men {"&"} WomenPost Op Knee Leg Compression, Stabilizer {"&"} Support Wrap for Swollen ACL, MCL, Tendon, Athletic Injury, Ligament {"&"} Meniscus Injuries –Anti Slip {"&"} Universal Size</p>
                            <p className="shop-price">$115.00</p>
                            <button className="shop-btn">Buy</button>
                        </div>
                        <div className="shop-div">
                        <img src={Product6} alt="des" className="shop-img"/>
                            <p className="shop-text">Air Gel Ankle Brace Stabilizer Stirrup UniversalRigid Medial & Lateral Shells minimize ankle rotation and inversion/eversion</p>
                            <p className="shop-price">$26.00</p>
                            <button className="shop-btn">Buy</button>
                            </div>
                        </div>                    
                    </div>

                </div>
        )
    }
}

export default products
